import React, { useEffect, useState, useRef } from 'react';
import { BsCaretDownFill, BsJustify, BsPersonCircle } from 'react-icons/bs';
import { IoLogOutOutline } from 'react-icons/io5';
import { useNavigate } from 'react-router-dom';
import { MdNotifications } from 'react-icons/md';
import { FaRegMoon } from "react-icons/fa";
import { PiSunBold } from "react-icons/pi";
import { GetUserEmail, LogOut } from './services/api';
import { IoBookOutline } from "react-icons/io5";
import Guide from '../Pages/Guide';


export default function Header({ title, OpenSidebar, unread, setPanelOpen }) {
  const [open, setOpen] = useState(false);
  const [darkMode, setDarkMode] = useState(false);
  const dropdownRef = useRef(null);
  const [showGuide, setShowGuide] = useState(false);
  const [userEmail, setUserEmail] = useState('');


  // Sync darkMode with localStorage on mount
  useEffect(() => {
    const storedTheme = localStorage.getItem('App') || 'light';
    setDarkMode(storedTheme === 'dark');
    document.documentElement.setAttribute('data-bs-theme', storedTheme);
    document.body.setAttribute('data-bs-theme', storedTheme);
    const getUserEmail = async () => {
      try {
      const response = await GetUserEmail();
      if (response && response.d) {
        setUserEmail(response.d);
      } else {
        // User is not logged in, redirect to login page
        navigate("/");
      }
      }
      catch (error) {
        console.log('validation error');
      }
    }
    getUserEmail();
  }, []);

  // Apply theme whenever darkMode changes
  useEffect(() => {
    const theme = darkMode ? 'dark' : 'light';
    document.documentElement.setAttribute('data-bs-theme', theme);
    document.body.setAttribute('data-bs-theme', theme);
    localStorage.setItem('App', theme);
  }, [darkMode]);

  // Initialize theme on mount: respect existing data-bs-theme on body/html or stored value
  // useEffect(() => {
  //   const body = document.querySelector('body');
  //   const html = document.querySelector('html');
  //   const bodyTheme = body ? body.getAttribute('data-bs-theme') : null;
  //   const htmlTheme = html ? html.getAttribute('data-bs-theme') : null;
  //   const stored = localStorage.getItem('App');

  //   if (bodyTheme === 'dark' || htmlTheme === 'dark' || stored === 'dark') {
  //     setDarkMode(true);
  //   } else {
  //     setDarkMode(false);
  //   }
  // }, []);

  // // Apply theme whenever darkMode changes
  // useEffect(() => {
  //   const theme = darkMode ? 'dark' : 'light';
  //   const body = document.querySelector('body');
  //   const html = document.querySelector('html');
  //   if (body) body.setAttribute('data-bs-theme', theme);
  //   if (html) html.setAttribute('data-bs-theme', theme);
  //   localStorage.setItem('App', theme);
  // }, [darkMode]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setOpen(false);
      }
    };

    if (open) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [open]);
  const navigate = useNavigate();
  const handleLogout = async () => {
    try {
      const response = await LogOut();
      if (response.status === 200) {
        navigate('/', { replace: true })
        localStorage.removeItem("dashboardGuide");
      }
      else {
        console.log('Error while logout');
      }
    } catch (error) {
      console.log('Error: ', error)
    }
    //document.cookie = "sckietman=; path=/; expires=Thu, 01 Jan 1970 00:00:00 UTC;";
    // if (document.cookie = "sckietman=; path=/;") {      
    //   navigate("/");
    // }
    // else {
    //   navigate("/");
    // }
    setOpen(false);
  }
  return (
    <header className='header'>
      <div className='d-flex align-items-center'>
        {/* <div className='menu-icon'>
          <BsJustify className='icon align-item-center' onClick={OpenSidebar} />
        </div> */}
        <h4 className='ms-3 mb-0'>{title}</h4>
      </div>
      <div className='header-right d-flex align-items-center gx-2'>

        <div className='form-check form-switch theme-switch d-flex align-items-center justify-content-center'>
          <input className='form-check-input' type='checkbox' role='switch' id='theme-switch-toggle' checked={darkMode} onChange={(e) => setDarkMode(e.target.checked)} />
          <label className='form-check-label ms-2 switch-icon' htmlFor='theme-switch-toggle'>
            <FaRegMoon className='moon' />
            <PiSunBold className='sun' />
          </label>
        </div>

        <div style={{ position: "relative", display: "block", cursor: "pointer" }}>
          <MdNotifications className='icon_header' onClick={() => { setOpen(false); setPanelOpen(prev => !prev); }} />
          {unread > 0 && (
            <span
              style={{
                position: 'absolute',
                top: '-6px',
                right: '6px',
                background: 'red',
                color: '#fff',
                borderRadius: '50%',
                fontSize: '9px',
                padding: '2px 6px',
              }}
            >
              {unread}
            </span>
          )}

        </div>

        <div style={{ position: "relative" }} ref={dropdownRef}>
          <div className='d-flex align-items-center user-dropdown'
            onClick={() => { setPanelOpen(false); setOpen(prev => !prev); }}>
              <BsPersonCircle className='icon_header' />
              <div><span className='user_email'>{userEmail.split('@')[0]}</span></div>
              <BsCaretDownFill className='icon_header arrow-down' />

          </div>

          {open && (
            <div
              style={{
                position: "absolute",
                top: "55px",
                right: 0,
                boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                backdropFilter: "blur(10px)",
                background: "var(--default-color)",
                borderRadius: "8px",
                padding: "18px 20px",
                zIndex: 1000,
                color: "var(--text-color)",
              }}
            >
              <div className='d-flex align-items-center'>
                <span className='user_email_fl'>{userEmail.split('@')[0].substring(0, 2)}</span>
                <span className='user_email'>{userEmail}</span>
              </div>
              <div className='menu-btn logout' onClick={() => { setShowGuide(true); setOpen(false); }} >
                <IoBookOutline />
                User Guide
              </div>

              <div className="menu-btn logout"
                onClick={handleLogout}>

                <IoLogOutOutline />
                Logout
              </div>
            </div>
          )}
        </div>
      </div>
      <Guide show={showGuide} onHide={() => setShowGuide(false)} />


    </header>
  )
}